export default "__VITE_ASSET__CBv9LLMo__"